import { createEnumHelper } from "@/utils/createEnumHelper";

/**
 * 模板流程编码
 */
export const FLOW_CODES = {
  /**
   * 供应商物料冻结
   */
  MATERIAL_BLOCK: "MATERIAL_BLOCK",
  /**
   * 供应商黑名单
   */
  SUPPLIER_BLACK_LIST: "SUPPLIER_BLACK_LIST",
  /**
   * 寻源申请
   */
  SOURCING_APPLICATION_20251202: "SOURCING_APPLICATION_20251202",
} as const;

export type FlowCode = (typeof FLOW_CODES)[keyof typeof FLOW_CODES];

/**
 * 流程办理时[必传] 跳转类型(PASS审批通过 REJECT退回)
 */
export type FlowSkipType = "PASS" | "REJECT";

/**
 * 供应商物料冻结流程
 */
export const MATERIAL_BLOCK_FLOW_MODE = {
  /**
   * 申请冻结
   */
  APPLY_BLOCK: "APPLY_BLOCK",
  /**
   * 申请冻结审批
   */
  APPLY_BLOCK_CHECK: "APPLY_BLOCK_CHECK",
  /**
   * 查看
   */
  VIEW: "VIEW",
  /**
   * 申请解冻
   */
  APPLY_UNBLOCK: "APPLY_UNBLOCK",
  /**
   * 申请解冻审批
   */
  APPLY_UNBLOCK_CHECK: "APPLY_UNBLOCK_CHECK",
  /**
   * 重新申请冻结
   */
  REAPPLY_BLOCK: "REAPPLY_BLOCK",
} as const;

export type MaterialBlockFlowMode =
  (typeof MATERIAL_BLOCK_FLOW_MODE)[keyof typeof MATERIAL_BLOCK_FLOW_MODE];

/**
 * 供应商黑名单
 */
export const BLACKLIST_FLOW_MODE = {
  /**
   * 移入申请
   */
  ADD_TO_APPLY: "ADD_TO_APPLY",
  /**
   * 移入申请-查看
   */
  ADD_TO_APPLY_VIEW: "ADD_TO_APPLY_VIEW",
  /**
   * 移出申请
   */
  REMOVE_FROM_APPLY: "REMOVE_FROM_APPLY",
  /**
   * 移出申请-查看
   */
  REMOVE_FROM_APPLY_VIEW: "REMOVE_FROM_APPLY_VIEW",
};

export type BlacklistFlowMode =
  (typeof BLACKLIST_FLOW_MODE)[keyof typeof BLACKLIST_FLOW_MODE];
/**
 * 流程状态
 * 0待提交 1审批中 2审批通过 4终止 5作废 6撤销 8已完成 9已退回 10失效 11拿回
 */
export const FLOW_STATUS = {
  /**
   * 待提交
   */
  PENDING_SUBMIT: "0",

  /**
   * 审批中
   */
  APPROVING: "1",

  /**
   * 审批通过
   */
  APPROVED: "2",

  /**
   * 终止
   */
  TERMINATED: "4",

  /**
   * 作废
   */
  VOIDED: "5",

  /**
   * 撤销
   */
  REVOKED: "6",

  /**
   * 已完成
   */
  COMPLETED: "8",

  /**
   * 已退回
   */
  RETURNED: "9",

  /**
   * 失效
   */
  EXPIRED: "10",

  /**
   * 拿回
   */
  TAKEN_BACK: "11",
} as const;

export type FlowStatusKey = keyof typeof FLOW_STATUS;
export type FlowStatusCode = (typeof FLOW_STATUS)[FlowStatusKey];

export const FLOW_STATUS_ZH: Record<keyof typeof FLOW_STATUS, string> = {
  PENDING_SUBMIT: "待提交",
  APPROVING: "审批中",
  APPROVED: "审批通过",
  TERMINATED: "终止",
  VOIDED: "作废",
  REVOKED: "撤销",
  COMPLETED: "已完成",
  RETURNED: "已退回",
  EXPIRED: "失效",
  TAKEN_BACK: "拿回",
};

export const { options: FLOW_STATUS_OPTIONS } = createEnumHelper(
  FLOW_STATUS,
  FLOW_STATUS_ZH,
);

/**
 * 流程类型对应的任务标题数据源
 */
export const FlowTypeTitles = [
  {
    documentTypeCode: "ZHUN_RU_SHEN_QING",
    documentType: "准入申请",
    withSupplier: true,
  },
  {
    documentTypeCode: "SUPPLIER_REGISTER",
    documentType: "供应商注册",
    withSupplier: true,
  },
  {
    documentTypeCode: "ZHUN_RU_PING_GU",
    documentType: "准入评估",
    withSupplier: true,
  },
  {
    documentTypeCode: "SOURCING_APPLICATION_20251202",
    documentType: "寻源需求申请流程 (20251202)",
    withSupplier: false,
  },
  {
    documentTypeCode: "SUPPLIER_SUB_REGISTER",
    documentType: "供应商子账号注册",
    withSupplier: true,
  },
  {
    documentTypeCode: "MATERIAL_BLOCK",
    documentType: "物料冻结",
    withSupplier: true,
  },
  {
    documentTypeCode: "SUPPLIER_INFO_UPDATE",
    documentType: "供应商修改信息",
    withSupplier: true,
  },
  {
    documentTypeCode: "SUPPLIER_BLACK_LIST",
    documentType: "供应商黑名单",
    withSupplier: true,
  },
  {
    documentTypeCode: "SUPPLIER_RISK_REGISTER",
    documentType: "供应商风险登记",
    withSupplier: true,
  },
];
